import { render } from "./SavedIdeasFilters.vue?vue&type=template&id=2de81d22"
import script from "./SavedIdeasFilters.vue?vue&type=script&lang=js"
export * from "./SavedIdeasFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__